// extracted by mini-css-extract-plugin
export default {"header":"Header_header__Lhnr8","title":"Header_title__rzFD1","logo":"Header_logo__nZ7K6","actions":"Header_actions__AB5lA"};